export function updateIcons() {
  grunticon.embedIcons(grunticon.getIcons(grunticon.href));
}
